import { FormEvent, useState } from 'react';
import { IVerifyGpsNumberResponse } from '@nkr/store/index';
import { Alert, Button, ControlLabel, FormControl, FormGroup, HelpBlock, Panel } from 'react-bootstrap'

interface IProps {
    id: number,
    imei: string,
    gpsNumber: string,
    vendorId: number,
    onChange: (field: string, value: any) => void,
    onSave: () => void,
    onCancel: () => void,
    verifyGpsNumber: (deviceId: number, gpsNumber: number) => Promise<IVerifyGpsNumberResponse>
}

enum GpsNumberStatus {
    Valid = 1,
    Invalid = 0,
    Existing = -1
}

const AddEdit = (props: IProps) => {
    const [validImei, setValidImei] = useState(true);
    const [gpsNumberStatus, setGpsNumberStatus] = useState(GpsNumberStatus.Valid);
    const [dirty, setDirty] = useState(false);

    const handleFieldChange = (e: FormEvent<FormControl & HTMLInputElement & HTMLSelectElement>) => {
        let { name, value } = e.currentTarget;
        props.onChange(name, value);
    };

    const handleSave = async () => {
        let newValidImei = props.imei != '';
        let newGpsNumberStatus = (props.gpsNumber != '' && isNaN(Number(props.gpsNumber)) == false) ? GpsNumberStatus.Valid : GpsNumberStatus.Invalid;

        if (newGpsNumberStatus == GpsNumberStatus.Valid) {
            let response = await props.verifyGpsNumber(props.id, parseInt(props.gpsNumber));

            if (response.data.success) {
                if (response.data.results.exists == true) {
                    newGpsNumberStatus = GpsNumberStatus.Existing;
                }
            }
        }

        setValidImei(newValidImei);
        setGpsNumberStatus(newGpsNumberStatus);
        setDirty(true);

        if (newValidImei && newGpsNumberStatus == GpsNumberStatus.Valid) {
            props.onSave();
        }
    }

    return (
        <Panel bsStyle='info'>
            <Panel.Heading>{props.id == 0 ? 'Add GPS Device' : 'Edit GPS Device'}</Panel.Heading>
            <Panel.Body>
                {dirty && (!validImei || gpsNumberStatus != GpsNumberStatus.Valid) &&
                    <Alert bsStyle='danger' bsSize='sm'>
                        The items in red are not valid...
                    </Alert>
                }

                <FormGroup validationState={dirty && !validImei ? 'error' : null}>
                    <ControlLabel>IMEI</ControlLabel>
                    <FormControl
                        name='imei'
                        value={props.imei}
                        onChange={handleFieldChange}
                    />
                    {!validImei && (
                        <HelpBlock>The IMEI is required</HelpBlock>
                    )}
                </FormGroup>

                <FormGroup validationState={dirty && gpsNumberStatus != GpsNumberStatus.Valid ? 'error' : null}>
                    <ControlLabel>GPS #</ControlLabel>
                    <FormControl
                        name='gpsNumber'
                        value={props.gpsNumber}
                        onChange={handleFieldChange}
                    />
                    {gpsNumberStatus == GpsNumberStatus.Existing && (
                        <HelpBlock>The GPS # is already assigned to another device</HelpBlock>
                    )}

                    {gpsNumberStatus == GpsNumberStatus.Invalid && (
                        <HelpBlock>The GPS # is required</HelpBlock>
                    )}
                </FormGroup>

                <FormGroup>
                    <ControlLabel>Vendor</ControlLabel>
                    <FormControl
                        componentClass='select'
                        name='vendorId'
                        style={{ width: '100%' }}
                        value={props.vendorId}
                        onChange={handleFieldChange}
                    >
                        <option value={0}>Newgate</option>
                        <option value={1}>Btracking</option>
                    </FormControl>
                </FormGroup>
            </Panel.Body>
            <Panel.Footer>
                <Button bsStyle='primary' onClick={handleSave}>Save</Button>&nbsp;
                <Button onClick={props.onCancel}>Cancel</Button>
            </Panel.Footer>
        </Panel>
    );
}

export default AddEdit;